import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-1-8h2V6H9v4zm0 4h2v-2H9v2z",
  fillRule: "evenodd"
});

var SvgAlertMinor = function SvgAlertMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgAlertMinor as S };
